import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  UpdateMinesProviderConfigFormContext,
  UpdateMinesProviderConfigFormState,
  updateMinesProviderConfigFormStateDefault,
  updateMinesProviderConfigSchemaDefault,
} from '@Forms/providers/UpdateMinesProviderConfigFormContext';

export const UpdateMinesProviderConfigFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<UpdateMinesProviderConfigFormState>>>(
    updateMinesProviderConfigSchemaDefault
  );
  const methods = useForm({
    defaultValues: updateMinesProviderConfigFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <UpdateMinesProviderConfigFormContext.Provider value={value}>
      {children}
    </UpdateMinesProviderConfigFormContext.Provider>
  );
};
